export default function(name: string, src: string, additionalAttributes: {[key: string]: string}, cb: () => void): void {
  const tagLoaded: string = `___${name}ScriptLoaded___`
  const tagLoading: string = `___${name}ScriptLoading___`
  if (window[tagLoaded] === undefined) {
    window[tagLoaded] = false;
  }

  if (window[tagLoaded]) {
    cb();
    return;
  }


  if (window[tagLoading] === undefined) {
    window[tagLoading] = false;
  }

  if (window[tagLoading]) {
    const waitInterval = setInterval(() => {
      if (window[tagLoaded]) {
        clearInterval(waitInterval);
        cb();
      }
    }, 100);
    return;
  }

  window[tagLoading] = true;
  const s = document.createElement("script");
  s.setAttribute("src", src);
  for (let key in Object.keys(additionalAttributes)) {
    //s.setAttribute(key, additionalAttributes[key])
  }
  s.async = true;
  s.addEventListener("load", () => {
    window[tagLoaded] = true;
    window[tagLoading] = false;
    cb();
  }, false);
  document.body.appendChild(s);
}
